import React from 'react';
import PropTypes from 'prop-types';
import { useTable } from 'react-table';
import { useSticky } from 'react-table-sticky';

const AthleteResultsBaseGrid = ({
  columns, data, onExerciseClick, buildHref,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useSticky,
  );

  return (
    <div className='tableWrapper sticky'>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell, cellIndex) => {
                  const cellProps = cell.getCellProps();
                  if (cellIndex !== 0) {
                    return (
                      <td {...cellProps}>
                        {cell.render('Cell')}
                      </td>
                    );
                  }
                  // First column rendered as a link
                  const href = buildHref ? buildHref(row.original) : '#';
                  return (
                    <td {...cellProps}>
                      <a
                        href={href}
                        onClick={(e) => {
                          const isModified = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
                          if (!isModified) {
                            e.preventDefault();
                            onExerciseClick(row.original);
                          }
                        }}
                        className='exerciseLink'
                        style={{ display: 'block', color: 'inherit', textDecoration: 'none' }}
                      >
                        {cell.render('Cell')}
                      </a>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

AthleteResultsBaseGrid.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    Header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    accessor: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    id: PropTypes.string,
    Cell: PropTypes.func,
    sticky: PropTypes.string,
  })).isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      exercise: PropTypes.string,
      completedExercise: PropTypes.string,
      assignedExercise: PropTypes.string,
      exerciseType: PropTypes.string,
    }),
  ).isRequired,
  onExerciseClick: PropTypes.func,
  buildHref: PropTypes.func,
};

AthleteResultsBaseGrid.defaultProps = {
  onExerciseClick: undefined,
  buildHref: undefined,
};

export default AthleteResultsBaseGrid;
